import { Data } from "../Data";

export class UpdateCreditCard extends Data {
  constructor(options: any) {
    super({
      api: "/Organization/Admin/Billing/CreditCard",
      postData: options.details,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options
    });
  }

  static post(context: any, details: any) {
    return new Promise(
      (resolve, reject) =>
        new UpdateCreditCard({ resolve, reject, context, details, method: "post" })
    );
  }
}
